module.exports = __webpack_public_path__ + "img/rtap.5d53857f.png";